<section class="breadcrumb-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="breadcrumb-title">
					<h1>Mandatory Disclosure</h1>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section-lg std-scholarship">
	<div class="container">
		<div class="sec-title text-center">
			<h2>Mandatory <span>Disclosure</span></h2>

		</div>
		<div class="row row-50">
			<div class="col-md-3">
				<div class="vertical-tabs">
					<ul class="nav nav-pills flex-column" id="myTab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab"
								aria-controls="tab1" aria-selected="true">FRA
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab"
								aria-controls="tab3" aria-selected="false">GENERAL INFORMATION</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab"
								aria-controls="tab3" aria-selected="false">AICTE MANDATORY DISCLOSURE</a>
						</li>
						
					</ul>
				</div>
			</div>
			<div class="col-md-9">
				<div class="tab-content" id="myTabContent">
					<div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
						<div class="section-title">
							<h4>FRA</h4>
						</div>
					
					</div>
					<div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
						<div class="section-title">
							<h4>GENERAL INFORMATION
							</h4>

						</div>
					
					</div>
					<div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
						<div class="section-title">
							<h4>AICTE MANDATORY DISCLOSURE</h4>

						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</section>
